export default {
    template: `
        <div class="background"></div>
        <div class="flexy-column">
            <div class="container">
                <h1>Contact Us</h1>
                <p>
                    The best way to contact us is via email. You can contact us via our socials, but we may take longer to get back to you.
                </p>
                <p>
                    Bookings and General Enquiries:<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;<a href="mailto:hello@kingearthquake.uk" class="highlight">hello@kingearthquake.uk</a>
                </p>
                <p>
                    Website Support:<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;<a href="mailto:support@kingearthquake.uk" class="highlight">support@kingearthquake.uk</a>
                </p>
                <p>
                    Privacy and Data Enquiries:<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;<a href="mailto:privacy@kingearthquake.uk" class="highlight">privacy@kingearthquake.uk</a>
                </p>
                <p>
                    Legal or Contractual Enquiries:<br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;<a href="mailto:legal@kingearthquake.uk" class="highlight">legal@kingearthquake.uk</a>
                </p>
            </div>
        </div>
    `,
    onMount() {
        document.body.classList.add("frame");
    },
    onUnmount() {
        document.body.classList.remove("frame");
    },
};
